import Cookies from 'js-cookie'

function isEqualObject(preObj, nextObj) {
  const preObjkeys = Object.keys(preObj)
  const nextObjkeys = Object.keys(nextObj)
  if (preObjkeys.length !== nextObjkeys.length) {
    return false
  }
  for (const key in preObj) {
    // eslint-disable-next-line eqeqeq
    if (preObj[key] != nextObj[key]) {
      return false
    }
  }

  return true
}
// const cacherouteActionTypeMapper = new Map([
//   ['ADD', ],
//   ['DELETE', ],
//   ['BACK', ],
// ])

const app = {
  state: {
    sidebar: {
      opened: !Number(Cookies.get('sidebarStatus')),
      withoutAnimation: false,
    },
    device: '',
    hoverMenuShow: false, // 是否显示hover二级菜单
    cacheRouteList: [], // 主要 缓存路由标签
    cacherouteActionType: null, // 执行动作的枚举
    quneWaitRefreshRoute: [], // 等待 刷新路由
  },
  mutations: {
    // 添加tab缓存路由
    ADD_CACHE_ROUTE(state, cacheRoute) {
      const cacheRouteList = [...state.cacheRouteList]
      /** 需要将其他的active换成false 当前这个 */
      let someOne
      let someOneIndex = -1
      for (let i = 0; i < cacheRouteList.length; i++) {
        const item = cacheRouteList[i]
        if (item.path === cacheRoute.path &&
          item.name === cacheRoute.name &&
          item.title === (cacheRoute.meta.resourceName || cacheRoute.meta.title)) {
          item.active = true
          someOne = item
          someOneIndex = i
          continue
        }
        item.active = false
      }

      // 标签数大于1且包含首页, 去除首页标签
      if (cacheRoute.name !== 'welcome' && cacheRouteList.length > 0) {
        const ind = cacheRouteList.findIndex((i) => i.title === '首页')
        ind > -1 && cacheRouteList.splice(ind, 1)
      }

      // 判断是否在缓存中存在
      // 如果存在 就不在新增
      if (someOne) {
        /** 如果当前不是活跃标签 需要特别标记vnode 判断所active的标签是否参数相同 重点看query */
        if (!isEqualObject({ ...someOne.query }, { ...cacheRoute.query })) {
          let _query = cacheRoute.query // 新的参数
          // 刷新 不更改原有参数
          if (Object.hasOwnProperty.call(cacheRoute.query, 'cashRefresh')) {
            delete _query.cashRefresh
            _query = { ...someOne.query, ..._query } // 旧的参数
          }
          // buff 是否需要沿用 之前的参数
          this.commit('QUNE_WAIT_REFRESH_ROUTE', { ...cacheRoute, query: { ..._query } })
        }
        // 给当前选中的标签
        someOne = {
          ...someOne,
          ...cacheRoute,
          active: true,
        }
        cacheRouteList.splice(someOneIndex, 1, someOne)
        state.cacheRouteList = [...cacheRouteList]
        return
      }
      // 当前缓存超过 19 将第一个剔除
      if (cacheRouteList.length > 19) {
        // 把关闭标签从标签集合中移除
        const obj = cacheRouteList[0]
        this.commit('QUNE_WAIT_REFRESH_ROUTE', { ...obj })
        cacheRouteList.splice(0, 1)
      }

      const perObj = {
        ...cacheRoute,
        title: cacheRoute.meta.resourceName || cacheRoute.meta.title,
        active: true,
        keepAlive: cacheRoute.meta.keepAlive,
      }

      cacheRouteList.push(perObj)
      state.cacheRouteList = [...cacheRouteList]
    },
    DELETE_CACHE_ROUTE(state, { currentRoute, callback }) {
      // 获取关闭页签的索引
      const ind = state.cacheRouteList.findIndex((item) => item.path === currentRoute.path)
      // 没有缓存这个页组件 不需要任何操作
      if (ind === -1) return

      // 把关闭标签从标签集合中移除
      state.cacheRouteList.splice(ind, 1)

      /** 重新计算应该滚动到的tab */
      // 获取当前标签集合的长度
      const len = state.cacheRouteList.length
      // 获取当前需要处理高亮页签数据的索引,主要是判断删除标签是否是最后一个标签
      // 如果被删除标签是最后一个标签，则高亮标签索引为当前删除标签索引
      // 如果被删除标签不是最后一个，高亮标签索引则显示当前删除标签索引前移（-1）
      const currentIndex = ind <= len - 1 ? ind : ind - 1
      // 去判断当前标签集合中是否存在高亮标签，如果存在高亮标签
      const isActiveTag = state.cacheRouteList.some((item) => !!item.active)
      // 如果没有高亮标签，则重新定义高亮标签
      console.log('isActiveTag', isActiveTag)
      if (!isActiveTag) {
        // 设置高亮页签
        const pathRoute = state.cacheRouteList[currentIndex]
        pathRoute.active = true
        // 跳转高亮页签路由 跳走
        console.log('pathRoute', pathRoute)
        callback && callback(pathRoute)
      }
    },
    QUNE_WAIT_REFRESH_ROUTE(state, currentRoute) {
      const ind = state.quneWaitRefreshRoute.findIndex((item) => item.path === currentRoute.path)
      if (!currentRoute.active && ind === -1) {
        state.quneWaitRefreshRoute.push(currentRoute)
      }
    },
    DELETE_QUNE_WAIT_REFRESH_ROUTE(state) {
      state.quneWaitRefreshRoute = []
    },

    /** 活跃当前用户 */
    ACTIVE_CACHE_ROUTE(state, aimRoute) {
      state.cacheRouteList.forEach((item) => {
        if (aimRoute.name === item.name) {
          item.active = true
        }
      })
    },


    SET_HOVER_MENU_SHOW(state, b) {
      state.hoverMenuShow = b
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_SIDEBAR: (state) => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
  },
  actions: {
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    ToggleDevice() {},
    FetchOpenedCitiesV2() {},
  },
}

export default app
